export const resolveLocale = () => {
  return (
    localStorage.getItem('locale') || navigator.language?.split('-')[0] || 'en'
  );
};
